<template>
<div class="login-wrapper">
  <div class="login">
    <h1>巡回点検業務管理システム</h1>
    <form class="login-form" @submit.prevent="tryLogin">
      <div class="form-group group1">
        <input type="text" class="form-control" ref="textInputUsername"
          placeholder="ログインID" v-model="loginForm.username">
        <input type="password" class="form-control" ref="textInputPassword"
          placeholder="パスワード" v-model="loginForm.password">
        <div v-if="showErrorMessage" class="text-danger text-center">
          <label class="small">
            ログインIDまたはパスワードが間違っています
          </label>
        </div>
      </div>
      <button type="submit" class="btn btn-primary btn-lg login-btn">
        <i class="fas fa-sign-in-alt"></i>
        ログイン
      </button>
    </form>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'login',
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
      },
      showErrorMessage: false,
    }
  },
  created() {
    this.$store.dispatch('user/getMe')
      .then(() => {
        // redirect to top if already logged in
        this.$router.replace({ name: 'Top' })
      })
      .catch(() => {
        // nothing to do
      })
  },
  methods: {
    // iOSのchromeだとautofillでchangeが効かないぽいのでがんばる
    ensureLoginFormValuesSynced() {
      const username = this.$refs.textInputUsername.value
      const password = this.$refs.textInputPassword.value
      this.loginForm.username = username
      this.loginForm.password = password
    },
    async tryLogin() {
      this.showErrorMessage = false
      this.ensureLoginFormValuesSynced()

      // loginしようとするときは明示的に消す.
      // expiredなトークンを送り続けるとログインできないので.
      delete axios.defaults.headers.Authorization

      try {
        const res = await this.$store.dispatch('user/login', this.loginForm)
        await this.$store.dispatch('localStorage/set', {
          key: 'serverToken',
          val: res.access_token,
        })
        const redirectUrl = this.getRedirectUrlFromExtParams()
        location.href = redirectUrl || '/'
      } catch (e) {
        this.showErrorMessage = true
      }
    },
    getRedirectUrlFromExtParams() {
      const extParams = this.$store.getters['localStorage/extParams']
      if (!extParams || Object.keys(extParams).length === 0) { return null }
      // 一度読んだら捨てる
      this.$store.dispatch('localStorage/set', { key: 'extParams', val: {} })
      const tenkenType = extParams.tenken_type
      const baseId = extParams.base_id
      const detailId = extParams.detail_id

      if (tenkenType && baseId && detailId) {
        return `/${tenkenType}/${baseId}/detail/${detailId}`
      }

      return null
    },
  }
}
</script>

<style lang="scss" scoped>
.login-wrapper {
  height: 100%;
  width: 100%;
  padding-top: 60px;
}
.login {
  text-align: center;
}
.login-form {
  margin: 20px 0 0 0;
  .form-group.group1 {
    width: 240px;
    margin: 0 auto;
  }
}
.form-control {
  margin: 0 0 8px 0;
}
</style>
